(ns frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.fund-tab
  (:require
   [common.localization :as loc]
   [frontend.ui.page.lp-report-editor.step-2-data-gathering.tabs.common :as common]
   [frontend.ui.component.lp-portal.section.view :as section]
   [common.schema.entities.lp-portal.lp-report :as lp-report]))

(defn fund-view
  [report input-id]
  [:div
   [section/section
    (loc/tr :lp-fund-report
            [(get lp-report/hardcoded-fund-templates
                  (:lp-report/template-type report))
             (some-> report
                     :lp-report/data
                     :fund-name)])
    nil
    [common/fund-report-table report false input-id]]
   [section/section (loc/tr :lp-report-landing-page-data) nil
    [common/landing-page-table report]]
   [section/section (loc/tr :lp-report/investors) nil
    [common/fund-investors-table report false]]
   [section/section (loc/tr :lp-report/materials) nil
    [common/materials-table report report false]]])
